import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
    Autocomplete,
    Box,
    Checkbox,
    FormControl,
    MenuItem,
    TextField,
} from "@mui/material";

import { Fragment } from "react/jsx-runtime";

const MuiSelect = ({
    label,
    labelId,
    options,
    value,
    setValue,
    multiple,
    required,
    withChip,
    renderSelectAll,
    renderTooltip,
    error,
    useOption,
    renderOptionLabel,
    disableCloseOnSelect = false,
    dataCy,
    ...selectProps
}) => {
    const localValue = multiple ? value || [] : value;
    const populatedValue = multiple
        ? options?.filter((option) => localValue?.includes(option?.value))
        : options?.find((option) => localValue === option?.value);
    const allSelected =
        multiple &&
        Array.isArray(options) &&
        options.length > 0 &&
        populatedValue?.length === options.length;

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    return (
        <FormControl fullWidth error={error} data-cy={dataCy}>
            <Autocomplete
                value={populatedValue}
                multiple={multiple}
                options={Array.isArray(options) ? options : []}
                loading={!options}
                onChange={(_, value) => {
                    setValue(
                        multiple
                            ? useOption
                                ? value
                                : value?.map((item) => item?.value) || []
                            : value?.value,
                    );
                }}
                {...(multiple
                    ? {
                          renderOption: (props, option, { selected }) => {
                              const { key, ...optionProps } = props;
                              const index = props["data-option-index"];
                              return (
                                  <Fragment>
                                      {index === 0 &&
                                          multiple &&
                                          renderSelectAll && (
                                              <MenuItem
                                                  onClick={() => {
                                                      setValue(
                                                          allSelected
                                                              ? []
                                                              : options?.map(
                                                                    (option) =>
                                                                        option?.value,
                                                                ),
                                                      );
                                                  }}
                                              >
                                                  <Box
                                                      textAlign="center"
                                                      width="100%"
                                                  >
                                                      {allSelected
                                                          ? "Deselect all"
                                                          : "Select all"}
                                                  </Box>
                                              </MenuItem>
                                          )}
                                      <li key={key} {...optionProps}>
                                          <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selected}
                                          />
                                          {renderOptionLabel
                                              ? renderOptionLabel(option)
                                              : option.label}
                                      </li>
                                  </Fragment>
                              );
                          },
                      }
                    : {})}
                renderInput={(params) => (
                    <TextField {...params} label={label} />
                )}
                required={required}
                fullWidth
                disableCloseOnSelect={disableCloseOnSelect}
                error={error}
                {...selectProps}
            />
        </FormControl>
    );
};

export default MuiSelect;
